/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Google_Drive_Reconnect_RequiredInputs */

const en_google_drive_reconnect_required = /** @type {(inputs: Google_Drive_Reconnect_RequiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Listening can no longer access your Google Drive. Reconnect Google Drive to continue.`)
};

const es_google_drive_reconnect_required = /** @type {(inputs: Google_Drive_Reconnect_RequiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Listening ya no puede acceder a tu Google Drive. Vuelve a conectar Google Drive para continuar.`)
};

/**
* | output |
* | --- |
* | "Listening can no longer access your Google Drive. Reconnect Google Drive to continue." |
*
* @param {Google_Drive_Reconnect_RequiredInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const google_drive_reconnect_required = /** @type {((inputs?: Google_Drive_Reconnect_RequiredInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Google_Drive_Reconnect_RequiredInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_google_drive_reconnect_required(inputs)
	return en_google_drive_reconnect_required(inputs)
});